import { apiClient } from "./client";

export async function getProfile() {
    const res = await apiClient.get("/api/auth/profile");
    return res.data;
}

export async function login(email, password) {
    const res = await apiClient.post("/api/auth/login", {
        email: String(email || "").trim().toLowerCase(),
        password: String(password || ""),
    });
    return res.data;
}

export async function logout() {
    const res = await apiClient.post("/api/auth/logout");
    return res.data;
}
